import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        tabsModule: {
          module: () => import('./tabs.module').then((m) => m.TabsModule),
          cmsComponents: [
            SdvorSharedCmsComponents.RosaCMSTabComponentContainer,
            SdvorSharedCmsComponents.RosaCMSTabsComponent,
          ],
        },
      },
    }),
  ],
})
export class TabsLazyModule {}
